import React, { FC } from 'react';
import { useDispatch } from 'react-redux';
import { authActions } from 'src/state/auth/authActions';
import { PostRedirectAction } from 'src/config/postRedirectAction';
import { LoginRoute } from 'src/public/publicRoutes';
import { Course } from 'src/common/models/course';
import { CourseEvent } from 'src/common/models/event';
import { Button } from 'src/common/components/Button';
import { useGatsbyLikeNavigate } from 'src/common/migration/useGatsbyLikeNavigate';
import { useGatsbyLikeLocation } from 'src/common/migration/useGatsbyLikeLocation';
import { pageContextActions } from 'src/state/pageContext/pageContextActions';

export interface CourseEventGuestActionProps {
  course: Course;
  selectedCourseEvent: CourseEvent;
}

export const CourseEventGuestAction: FC<CourseEventGuestActionProps> = ({
  course,
  selectedCourseEvent,
}) => {
  const location = useGatsbyLikeLocation();
  const navigate = useGatsbyLikeNavigate();
  const dispatch = useDispatch();

  const onClick = () => {
    dispatch(
      authActions.setRedirectUrl({
        pathname: location.pathname,
        publicRoute: true,
        action: PostRedirectAction.CourseEventRegister,
        query: location.query,
      }),
    );
    dispatch(
      pageContextActions.setAuthCourseExcerpt({
        date: selectedCourseEvent.startDateTime,
        image: course.image,
        title: course.title,
      }),
    );
    navigate(LoginRoute, { replace: true });
  };

  return (
    <Button style={{ width: '100%' }} onClick={onClick}>
      Zapisz się bezpłatnie
    </Button>
  );
};
